import React, { useState, useEffect, useContext } from "react";
// import Header from "./Header";
import Header from "../components/dashboard/header";
import Footer from "./Footer";
import errorImg from '../assets/images/error-img.png';

const Diagnostics = () => {

    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);

    return (
        <>
            <Header />

            <section className="about-us-section">
                <div className="container">
                    <h3 className="txt-48">Diagnostics</h3>
                    <p className="txt-16">Precision Diagnostics. Lifelong Learning. Global Impact.</p>
                </div>
            </section>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-notfound">
                            <div className="no_data">
                                <img src={errorImg} />
                                <h3>Coming Up</h3>
                                <p>Stay tuned with us!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Diagnostics;
